import store, { resetStores } from 'src/store'
import {
  markClientLogoutInProgress,
  notifyLocalAuthStateChanged,
} from 'src/shared/auth/logoutSignals'
import { PORTAL_AVAILABILITY_OVERRIDES_STORAGE_KEY } from 'src/shared/config/portalAvailabilityRules'

export function logoutHandlerBusiness() {
  markClientLogoutInProgress()
  const languageCode = sessionStorage.getItem('languageCode')

  sessionStorage.clear()
  localStorage.removeItem('token')
  localStorage.removeItem('accessTokenExpiry')
  localStorage.removeItem('authorities')
  localStorage.removeItem('FCMToken')
  localStorage.removeItem('submittedFCMTokenForThisUser')
  localStorage.removeItem(PORTAL_AVAILABILITY_OVERRIDES_STORAGE_KEY)
  localStorage.removeItem('lastChosenFlow')

  sessionStorage.setItem(
    'languageCode',
    languageCode ? languageCode : navigator?.language || navigator?.userLanguage?.split('-')[0],
  )
  markClientLogoutInProgress()

  store.dispatch(resetStores())
  notifyLocalAuthStateChanged()
}
